import { Button, Tooltip, Typography } from "@material-ui/core";
import * as React from "react";
import { AuthContext, IAuthContextData } from "src/auth";
import {
  encryptPassword,
  validatePassword,
} from "src/services/PasswordService";
import Rest from "../../services/Rest";
import { BackgroundLogin } from "../shared/layout/background-login/BackgroundLogin";
import { CustomSnackbar } from "../shared/snackbar/CustomSnackbar";

const QUERY_CHANGE_PASSWORD_FIRST_ACCESS = ` query changePasswordFirstAccess($user:  BooksUserInput) { changePasswordFirstAccess(user: $user) } `;

// tslint:disable-next-line:no-empty-interface
export interface IFirstAccessProps {}

// tslint:disable-next-line:no-empty-interface
export interface IFirstAccessState {
  alert: {
    msg: string;
    open: boolean;
  };
  confirmPassword: string;
  newPassword: string;
  viewConfirmPassword: boolean;
  viewNewPassword: boolean;
}

export class FirstAccess extends React.Component<
  IFirstAccessProps,
  IFirstAccessState
> {
  constructor(props: IFirstAccessProps) {
    super(props);
    this.state = {
      alert: {
        msg: "",
        open: false,
      },
      confirmPassword: "",
      newPassword: "",
      viewConfirmPassword: false,
      viewNewPassword: false,
    };
  }

  public render() {
    return (
      <AuthContext.Consumer>
        {(auth: IAuthContextData) => (
          <>
            <CustomSnackbar
              msg={this.state.alert.msg}
              open={this.state.alert.open}
              onClose={this.onCloseAlert}
            />
            <BackgroundLogin>
              <div className="background-login-box">
                <Tooltip
                  disableHoverListener={true}
                  placement="bottom-end"
                  title={this.getValidationRules()}
                >
                  {this.getPasswordField(
                    "NewPassword",
                    this.state.viewNewPassword,
                    "Nova senha"
                  )}
                </Tooltip>
                {this.getPasswordField(
                  "ConfirmPassword",
                  this.state.viewConfirmPassword,
                  "Confirme sua nova senha"
                )}
                <Button
                  type="button"
                  onClick={() => this.submitPassword(auth)}
                >
                  Confirmar
                </Button>
              </div>
            </BackgroundLogin>
          </>
        )}
      </AuthContext.Consumer>
    );
  }

  private getPasswordField = (
    field: string,
    viewPass: boolean,
    label: string
  ) => {
    return (
      <div className="background-login-field">
        <label>{label}</label>
        <input
          autoComplete="off"
          type={viewPass ? "text" : "password"}
          onChange={this.handleChangePass(field)}
        />
        <span
          className={viewPass ? "icon-visibility visible" : "icon-visibility"}
          onClick={() => this.handleViewPass(field)}
        />
      </div>
    );
  };

  private getValidationRules = () => {
    return (
      <>
        <Typography color="inherit">Mínimo de 8 caracteres</Typography>
        <Typography color="inherit">1 letra maiúscula</Typography>
        <Typography color="inherit">1 letra minúscula</Typography>
        <Typography color="inherit">1 número</Typography>
        <Typography color="inherit">1 caracter especial</Typography>
        <Typography color="inherit">A senha não pode conter espaços em branco</Typography>
      </>
    );
  };

  private handleChangePass =
    (field: string) => (event: React.FormEvent<HTMLInputElement>) => {
      field === "NewPassword"
        ? this.setState({ newPassword: event.currentTarget.value })
        : this.setState({ confirmPassword: event.currentTarget.value });
    };

  private handleViewPass = (field: string) => {
    field === "NewPassword"
      ? this.setState({ viewNewPassword: !this.state.viewNewPassword })
      : this.setState({ viewConfirmPassword: !this.state.viewConfirmPassword });
  };

  private submitPassword = async (auth: IAuthContextData) => {
    const pass = this.state.newPassword;

    const validate = validatePassword(pass);

    if (validate) {
      this.setState({ alert: { msg: validate, open: true } });
      return;
    }

    if (pass !== this.state.confirmPassword) {
      this.setState({
        alert: { msg: "As senhas devem ser iguais.", open: true },
      });
      return;
    }

    if (!auth.user || !auth.user.id) {
      this.setState({
        alert: {
          msg: "Não foi possível prosseguir, usuário não identificado",
          open: true,
        },
      });
      auth.Logout();
      return;
    }

    const cryptPass = await encryptPassword(pass);

    const userToSend: any = {
      user: {
        email: auth.user.email,
        id: auth.user.id,
        password: cryptPass,
      },
    };

    const body = {
      operationName: "",
      query: QUERY_CHANGE_PASSWORD_FIRST_ACCESS,
      variables: userToSend,
    };

    Rest.GraphqlPOST(body)
      .then((data) => {
        if ( data && data.data && data.data.errors != null && data.data.errors !== undefined && data.data.errors.length > 0 ) {
          this.setState({ alert: { msg: data.data.errors[0].message.message, open: true } });
        } else {
          this.setState({ alert: { msg: "Senha alterada com sucesso!", open:  true } });
          auth.setLoginData(data.data.data.changePasswordFirstAccess);
        }
      })
      .catch((err) => {
        let msg = "Não foi possível alterar a senha.";
        if (!!err.message) {
          msg = err.message;
        }
        this.setState({ alert: { msg, open: true } });
      });
  };

  private onCloseAlert = () => {
    this.setState({ alert: { msg: "", open: false } });
  };
}



// WEBPACK FOOTER //
// ./src/component/first-access/FirstAccess.tsx